// TODO: após clonar o skeleton, ajustar os links de ambientes

/** CRA injeta `process` no bundle; em alguns contextos (iframe/extensão) pode faltar. */
function resolveReactAppEnv() {
	if (typeof process !== "undefined" && process.env) {
		const name = process.env.REACT_APP_ENV;
		if (name) {
			return name;
		}
		if (process.env.NODE_ENV === "production") {
			return "production";
		}
	}
	return "development";
}

const dev = {
	API_ENDPOINT_URL: "http://127.0.0.1/intelligenz/api",
	PUBLIC_PREFIX_PATH: "",
	API_SOCKET_ENDPOINT_URL: "http://127.0.0.1:8080/",
	API_SOCKET_SUFIX_PATH: "/intelligenz/socket.io",
};

const prod = {
	API_ENDPOINT_URL:
		"https://intelligenz-back-re9ar.ondigitalocean.app/intelligenx-back2/intelligenz/api",
	PUBLIC_PREFIX_PATH: "",
	API_SOCKET_ENDPOINT_URL:
		"https://intelligenz-back-re9ar.ondigitalocean.app/",
	API_SOCKET_SUFIX_PATH: "/intelligenx-back2/intelligenz/socket.io",
};

const test = {
	API_ENDPOINT_URL: "https://homolog.dimo.com.br/intelligenz-back/api",
	PUBLIC_PREFIX_PATH: "/intelligenz",
	API_SOCKET_ENDPOINT_URL: "https://homolog.dimo.com.br/",
	API_SOCKET_SUFIX_PATH: "/intelligenz-back/socket.io",
};

const getEnv = () => {
	switch (resolveReactAppEnv()) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
